import * as React from "react";
import { callApi } from "../../utils/api";
import { ADMIN_ROLE } from "../../utils/role";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import Select from "react-select";
import moment from "moment";
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;

export interface Bank {
    id: number;
    name: string;
}

interface AllProps {
    history: any;
}

const PROCESS_TYPES = [
    { key: "process", label: "Process" },
    { key: "verification", label: "Verification" },
    { key: "rectification", label: "Rectification" },
    { key: "final_approval", label: "Final Approval" },
];

const EMPTY_USER_MAPPINGS = {
    process: [],
    verification: [],
    rectification: [],
    final_approval: [],
};

const DISPLAY_NAME_LIMIT = 3;

class BankProductUserMapping extends React.Component<AllProps> {
    state = {
        bankList: [],
        products: [],
        bankproducts: [],
        users: [],
        userMappings: [],
        productToBeDeleted: "",
        isFileRefresh: false,
        selectedproduct: {
            id: 0,
            bank_id: 0,
            product_id: 0,
            login_amount: "",
            complete_amount: "",
            vetting_amount: "",
        },
        selectedMappingProduct: null as any,
        userMappingForm: { ...EMPTY_USER_MAPPINGS },
        userListModalTitle: "",
        userListModalNames: [] as string[],
        outreason: "",
        selectVal: false,
        isLoading: false,
        isMappingSaving: false,
    };

    async componentDidMount() {
        this.listBank();
        this.getBankList();
        this.listproduct();
        this.loadUsers();
        this.loadUserMappings();
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
    }

    getBankList = () => {
        callApi("GET", "bank_get.php")
            .then((res) => res.data)
            .then((response) => {
                this.setState({ bankList: response.data, isBankListLoaded: true });
            })
            .catch((err) => console.log(err));
    };

    listproduct = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "product_get.php")
            .then((res) => res.data)
            .then((response) => {
                this.setState({ products: response.data, isFileRefresh: true });
            })
            .catch((err) => console.log(err));
    };

    loadUsers = () => {
        callApi("GET", "user_get.php")
            .then((res) => res.data)
            .then((response) => {
                const users = (response.data || []).map((user: any) => ({
                    value: user.id,
                    label: `${user.name}${user.employeeId ? ` (${user.employeeId})` : ""}`,
                    ...user,
                }));
                this.setState({ users });
            })
            .catch((err) => console.log(err));
    };

    loadUserMappings = () => {
        callApi("GET", "bank_product_user_mapping_get.php")
            .then((res) => res.data)
            .then((response) => {
                this.setState({ userMappings: response.data || [] });
            })
            .catch((err) => console.log(err));
    };

    listBank = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "bank_product_get.php")
            .then((res) => res.data)
            .then((response) => {
                const files = response.data;
                if (files && files.length > 0) {
                    files.forEach((file: any, index: number) => {
                        Object.keys(file).forEach((fileKey) => {
                            file[fileKey] = !file[fileKey]
                                ? ""
                                : typeof file[fileKey] !== "string"
                                    ? String(file[fileKey])
                                    : file[fileKey];
                        });
                        file.index = index + 1;
                    });
                }
                this.setState({ bankproducts: files, isFileRefresh: true });
            })
            .catch((err) => console.log(err));
    };

    getMappedUserNames = (bankProductId: number, processType: string) => {
        return this.state.userMappings
            .filter(
                (row: any) =>
                    String(row.bank_product_id) === String(bankProductId) &&
                    row.process_type === processType
            )
            .map((row: any) => row.user_name);
    };

    openUserListModal = (file: any, processType: string, names: string[]) => {
        const label = PROCESS_TYPES.find((p) => p.key === processType)?.label || processType;
        this.setState({
            userListModalTitle: `${label} Users - ${file.bank_name} / ${file.product_name}`,
            userListModalNames: names,
        });
    };

    renderMappingSummary = (file: any, processType: string) => {
        const names = this.getMappedUserNames(file.id, processType);
        if (names.length === 0) {
            return "-";
        }
        if (names.length <= DISPLAY_NAME_LIMIT) {
            return names.join(", ");
        }
        const displayNames = names.slice(0, DISPLAY_NAME_LIMIT);
        return (
            <span>
                {displayNames.join(", ")}{" "}
                <a
                    href="#"
                    className="text-primary"
                    data-toggle="modal"
                    data-target="#mapping-users-list-modal"
                    onClick={(e) => {
                        e.preventDefault();
                        this.openUserListModal(file, processType, names);
                    }}
                >
                    Show all ({names.length})
                </a>
            </span>
        );
    };

    buildUserMappingForm = (bankProductId: number) => {
        const form = {
            process: [] as any[],
            verification: [] as any[],
            rectification: [] as any[],
            final_approval: [] as any[],
        };

        PROCESS_TYPES.forEach(({ key }) => {
            const mapped = this.state.userMappings.filter(
                (row: any) =>
                    String(row.bank_product_id) === String(bankProductId) &&
                    row.process_type === key
            );
            form[key] = mapped
                .map((row: any) =>
                    this.state.users.find((user: any) => String(user.value) === String(row.user_id))
                )
                .filter(Boolean);
        });

        return form;
    };

    addBank = () => {
        this.setState({ selectedproduct: Object.assign({}) });
    };

    editBank = (bank: any) => {
        this.setState({ selectedproduct: bank });
    };

    openUserMapping = (bankProduct: any) => {
        this.setState({
            selectedMappingProduct: bankProduct,
            userMappingForm: this.buildUserMappingForm(bankProduct.id),
        });
    };

    handleUserMappingChange = (processType: string, selectedOptions: any) => {
        this.setState({
            userMappingForm: {
                ...this.state.userMappingForm,
                [processType]: selectedOptions || [],
            },
        });
    };

    saveUserMapping = () => {
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const bankProductId = this.state.selectedMappingProduct?.id;

        if (!bankProductId) {
            ToastsStore.error("Please select a bank product");
            return;
        }

        const mappings: any = {};
        PROCESS_TYPES.forEach(({ key }) => {
            mappings[key] = (this.state.userMappingForm[key] || []).map((item: any) => item.value);
        });

        this.setState({ isMappingSaving: true });

        callApi("POST", "bank_product_user_mapping_save.php", {
            bank_product_id: Number(bankProductId),
            userid: userId,
            mappings,
        })
            .then((res) => res.data)
            .then((response) => {
                this.setState({ isMappingSaving: false });
                if (response.result) {
                    ToastsStore.success("User mappings saved successfully");
                    this.loadUserMappings();
                    $("#user-mapping-form").modal("hide");
                } else {
                    ToastsStore.error(response.message || "Failed to save user mappings");
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isMappingSaving: false });
                ToastsStore.error("Failed to save user mappings");
            });
    };

    saveBank = () => {
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        if (this.state.selectedproduct.id) {
            this.state.selectedproduct.id = Number(this.state.selectedproduct.id);
            const req = {
                userid: userId,
                ...this.state.selectedproduct,
            };
            callApi("POST", "bank_product_update.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        this.setState({ selectedproduct: {} });
                        ToastsStore.success("Updated Successfully");
                        this.listBank();
                    } else {
                        this.setState({ selectedproduct: {} });
                        ToastsStore.error("Not Updated");
                        this.listBank();
                    }
                })
                .catch((err) => console.log(err));
        } else {
            const req = {
                userid: userId,
                ...this.state.selectedproduct,
            };
            callApi("POST", "bank_product_insert.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        this.setState({ selectedproduct: {} });
                        ToastsStore.success("Saved Successfully");
                        this.listBank();
                    } else {
                        this.setState({ selectedproduct: {} });
                        ToastsStore.error("Not Inserted");
                        this.listBank();
                    }
                })
                .catch((err) => console.log(err));
        }
    };

    confirmDeleteBank = (modal: Bank) => {
        this.setState({ productToBeDeleted: modal.id });
    };

    deleteBank = () => {
        callApi("POST", "bank_product_delete.php", { id: this.state.productToBeDeleted })
            .then((res) => res.data)
            .then(() => {
                this.listBank();
            })
            .catch((err) => console.log(err));
    };

    handleChangeselect = (e: any, propName?: string, fieldType?: string) => {
        const fieldName = fieldType === "singleselect" ? propName : e.target.name;
        const fieldValue = fieldType === "singleselect" ? e.value : e.target.value;
        if (fieldName === "bank_id" || fieldName === "product_id") {
            const selectedproduct: any = this.state.selectedproduct;
            selectedproduct[fieldName] = fieldValue;
            this.setState({ selectedproduct });
        }
    };

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    };

    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");
        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    };

    getOutTime = () => {
        const date = new Date();
        const stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime));
        const outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        const Railway = date.getMinutes();
        if (Railway < 10) {
            const TotalMinutes = "0" + Railway;
            const ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        } else {
            const ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    };

    ouTime = () => {
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    };

    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), "seconds");
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason === "") {
            this.setState({ selectVal: true });
        } else {
            const obj = {
                file_id: JSON.parse(fileid1),
                user_id: JSON.parse(userid1),
                in_reason: JSON.parse(inreason),
                out_reason: this.state.outreason,
                intime: JSON.parse(intime),
                outtime: JSON.parse(outtime),
                insert_date: JSON.parse(outdate),
                total_seconds: secondsSpent,
                insert_id: insertId,
            };

            callApi("POST", "process_eod_insert.php", obj)
                .then((res) => res.data)
                .then(() => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    const process_officerId: any = localStorage.getItem("process_office_id");
                    const process_officer_id = JSON.parse(process_officerId);
                    const userid1Local: any = localStorage.getItem("user1");
                    const user_id = JSON.parse(userid1Local);
                    const take_file: any = localStorage.getItem("takenfile_id");
                    const getfileId: any = localStorage.getItem("currentfileId");
                    if (process_officer_id === user_id && take_file !== "" && take_file === getfileId) {
                        this.fileout(fileid1);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                });
        }
    };

    fileout = (fileid1: any) => {
        const fileId = JSON.parse(fileid1);
        const loginuser: any = localStorage.getItem("user1");
        const req = {
            id: fileId,
            reason: "File Out",
            created_by: JSON.parse(loginuser),
        };
        callApi("POST", "time_update.php", req)
            .then((res) => res.data)
            .then(() => {
                localStorage.removeItem("currentfileId");
            });
    };

    onchangeReason = (e: any) => {
        if (e.target.value === "Other") {
            this.setState({ in_reason: "", selectVal: false });
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else if (e.target.value === "select") {
            this.setState({ setResponse: false });
        } else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(), selectVal: false });
    };

    renderBankProductForm = (modalId: string) => (
        <div className="modal fade" id={modalId} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="template-select">
                                            <label className="col-form-label">Bank:</label>{" "}
                                            {this.state.bankList &&
                                                this.state.bankList.length > 0 &&
                                                this.state.bankList.map((opt: any) => {
                                                    opt.label = opt.name;
                                                    opt.value = opt.id;
                                                }) && (
                                                    <Select
                                                        options={this.state.bankList}
                                                        name="bank_id"
                                                        value={this.state.bankList.find(
                                                            (o: any) => o.value == this.state.selectedproduct.bank_id
                                                        )}
                                                        onChange={(e) => this.handleChangeselect(e, "bank_id", "singleselect")}
                                                    />
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="template-select">
                                            <label className="col-form-label">Product:</label>{" "}
                                            {this.state.products &&
                                                this.state.products.map((opt: any) => {
                                                    opt.label = opt.product;
                                                    opt.value = opt.id;
                                                }) && (
                                                    <Select
                                                        options={this.state.products}
                                                        name="product_id"
                                                        value={this.state.products.find(
                                                            (o: any) => o.value == this.state.selectedproduct.product_id
                                                        )}
                                                        onChange={(e) => this.handleChangeselect(e, "product_id", "singleselect")}
                                                    />
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">
                            Cancel
                        </button>
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.saveBank}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const user: any = localStorage.getItem("user");
        const role_id = user ? JSON.parse(user)["role_id"] : "";
        const columns = [
            { header: "ID", key: "index" },
            { header: "Bank Name", key: "bank_name" },
            { header: "Product Name", key: "product_name" },
            {
                header: "Process Users",
                td: (file: any) => this.renderMappingSummary(file, "process"),
            },
            {
                header: "Verification Users",
                td: (file: any) => this.renderMappingSummary(file, "verification"),
            },
            {
                header: "Rectification Users",
                td: (file: any) => this.renderMappingSummary(file, "rectification"),
            },
            {
                header: "Final Approval Users",
                td: (file: any) => this.renderMappingSummary(file, "final_approval"),
            },
            {
                header: "Actions",
                td: (file: any) => (
                    <div className="btn-group mb-2 mr-2">
                        <button type="button" className="btn btn-primary">
                            Action
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <div
                            className="dropdown-menu"
                            x-placement="top-start"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                transform: "translate3d(88px, -2px, 0px)",
                            }}
                        >
                            <a
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target="#user-mapping-form"
                                onClick={() => this.openUserMapping(file)}
                            >
                                Map Users
                            </a>
                            <a
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target="#product-form"
                                onClick={() => this.editBank(file)}
                            >
                                Edit
                            </a>
                            {role_id === ADMIN_ROLE && (
                                <a
                                    className="dropdown-item"
                                    style={{ float: "right" }}
                                    data-toggle="modal"
                                    data-target="#delete-bank"
                                    onClick={() => this.confirmDeleteBank(file)}
                                >
                                    Delete
                                </a>
                            )}
                        </div>
                    </div>
                ),
            },
        ];
        const data = this.state.bankproducts;

        return (
            <section className="pcoded-main-container">
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />{" "}
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Bank + Product User Mapping</h5>
                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="dt-responsive table-responsive">
                                                        <a
                                                            className="btn btn-primary m-b-20"
                                                            data-toggle="modal"
                                                            data-target="#product-form-insert"
                                                            onClick={this.addBank}
                                                        >
                                                            + Add Product
                                                        </a>
                                                        {this.state.isFileRefresh && data.length > 0 && (
                                                            <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.renderBankProductForm("product-form")}
                {this.renderBankProductForm("product-form-insert")}

                <div className="modal fade" id="mapping-users-list-modal" role="dialog" aria-hidden="true">
                    <div className="modal-dialog" role="document" style={{ maxHeight: "90vh" }}>
                        <div className="modal-content" style={{ maxHeight: "90vh", display: "flex", flexDirection: "column" }}>
                            <div className="modal-header" style={{ flexShrink: 0 }}>
                                <h5 className="modal-title">{this.state.userListModalTitle}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: "auto", maxHeight: "calc(90vh - 130px)" }}>
                                {this.state.userListModalNames.length > 0 ? (
                                    <ul className="mb-0 pl-3">
                                        {this.state.userListModalNames.map((name, index) => (
                                            <li key={`${name}-${index}`}>{name}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="mb-0 text-muted">No users mapped.</p>
                                )}
                            </div>
                            <div className="modal-footer" style={{ flexShrink: 0 }}>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="user-mapping-form" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Map Users - {this.state.selectedMappingProduct?.bank_name} /{" "}
                                    {this.state.selectedMappingProduct?.product_name}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {PROCESS_TYPES.map(({ key, label }) => (
                                    <div className="form-group" key={key}>
                                        <label className="col-form-label">{label} Users:</label>
                                        <Select
                                            isMulti
                                            closeMenuOnSelect={false}
                                            options={this.state.users}
                                            value={this.state.userMappingForm[key]}
                                            onChange={(selected) => this.handleUserMappingChange(key, selected)}
                                            placeholder={`Select ${label.toLowerCase()} users`}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isMappingSaving}
                                    onClick={this.saveUserMapping}
                                >
                                    {this.state.isMappingSaving ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "Save Mapping"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="delete-bank" role="dialog" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Bank & Product</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to delete this Bank & Product?</h6>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    No
                                </button>
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.deleteBank}>
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <div className="modal-body" style={{ padding: "30px 23px 29px 24px" }}>
                                <h3 style={{ margin: "auto", fontSize: "17px" }}>
                                    Please Select The Reason For To Close The File.No:
                                    {localStorage.getItem("currentfileId")}
                                </h3>
                            </div>
                            <div className="form-group" style={{ width: "74%", margin: "auto" }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: "8px" }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>
                                </select>
                                {this.state.selectVal ? (
                                    <p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>
                                        Please Select Your Reason{" "}
                                    </p>
                                ) : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: "27px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: "76px", fontSize: "17px" }}
                                >
                                    {this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "OK"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: "107px", fontSize: "14px", border: "1px solid black", height: "43px" }}
                                >
                                    Back To File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")}{" "}
                            </h5>
                            <div className="modal-body" style={{ padding: "30px 23px 29px 24px" }}>
                                <div className="form-group" style={{ width: "98%", margin: "auto" }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason"
                                        onChange={this.onchange}
                                    />
                                    {this.state.selectVal ? (
                                        <p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>
                                            Please Select Your Reason{" "}
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={() => this.outimeGet()}
                                    style={{ width: "76px", fontSize: "17px" }}
                                >
                                    {this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "OK"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={() => this.previousPop()}
                                    style={{ width: "76px", fontSize: "17px", border: "1px solid black" }}
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default BankProductUserMapping;
